import useDpcSessions from "../utils/useDpcSessions";
import useCategory from "../utils/useCategory";
import { Typography } from "@mui/material";
import moment from "moment";
import useCart from "../utils/useCart";

export default function DpcSessions(){

    const category = useCategory()

    const sessions = useDpcSessions()

    const { cart, setCart } = useCart();

    const handleClick = (session) => {

        setCart({ session: session.id });
    }
    
    return sessions.length > 0 && <>

        <Typography variant="h5" align="center">Accédez à votre session DPC à partir du :</Typography>

        <div className="apply-choices">

            {sessions
                .sort((a,b) => moment(a.start).diff(moment(b.start)))
                .map((s,i) => 
                    <div
                        key={s.id}
                        className="apply-choice" 
                        onClick={() => handleClick(s)}
                        style={s.id === cart.session ? {
                            backgroundColor: category?.color,
                            borderColor: category?.color,
                            color: 'white'
                        } : null}
                    >
                        <span>{sessionLabel(s, i)}</span>
                    </div>    
                )
            }

        </div>

    </>
}


export function sessionLabel(session, index = 0){

    const date = moment(session.start)

    /* if( date.valueOf() < Date.now() && index === 0 ) return "Dès maintenant"; // Ticket Notion 3b26a59e877f80a88762cb6422c7aa85 */

    return date.format('DD/MM/YYYY');
}